import React, { Fragment, useState } from "react";
import Footer from "../component/Footer";
import { HiArrowUpRight } from "react-icons/hi2";
import { Dialog, Transition } from "@headlessui/react";
import { RxCross1 } from "react-icons/rx";
import { motion } from "framer-motion";
import Modal from "../component/Modal";

export default function OurTeam1() {
  const [selectedItem, setSelectedItem] = useState({});
  const [type, setType] = useState("");
  const [openDialog, setOpenDialog] = useState(false);

  const ceo = [
    {
      name: "ดร. วรเดช พูนคำ",
      nickname: "ครูเติม",
      subject: "ผู้บริหาร | ติวเตอร์",
      imageUrl: "./img/kruterm.png",
      modalImg: "./img/kruterm_info.jpg",
    },
    {
      name: "ศรัญญา มงคลสิทธิ์",
      nickname: "เก๋",
      subject: "ผู้บริหาร",
      imageUrl: "./img/kae.png",
    },
  ];

  const tutor = [
    {
      name: "ครู วิธิวัสส์ ปราณสิริจิรภาส",
      nickname: "ครูบิ๊ก",
      subject: "ติวเตอร์",
      imageUrl: "./img/krubig.png",
      modalImg: "./img/krubig_info.jpg",
    },
    {
      name: "ครู ศรัญย์ อินทะผิว",
      nickname: "ครูพี",
      subject: "ติวเตอร์",
      imageUrl: "./img/krupee.png",
      modalImg: "./img/krupee_info.jpg",
    },

    {
      name: "ดร. กิตต์ ปัญญารัตน์",
      nickname: "ครูกิตต์",
      subject: "ติวเตอร์",
      imageUrl: "./img/krukit.png",
      modalImg: "./img/krukit_info.jpg",
    },
    {
      name: "ดร. สาริทธิ์ จารุชัยบวร",
      nickname: "ครูมีน",
      subject: "ติวเตอร์",
      imageUrl: "./img/krumean.png",
      modalImg: "./img/krumean_info.jpg",
    },
    {
      name: "ดร. วีระวัฒน์ คลอวุฒิมันตร์",
      nickname: "ครูวี",
      subject: "ติวเตอร์",
      imageUrl: "./img/kruwee.png",
      modalImg: "./img/kruwee_info.jpg",
    },
  ];
  return (
    <div>
      <div className="pt-24 pb-10 sm:pt-32  ">
        <div className="mx-auto max-w-screen-2xl px-6 lg:px-8">
          <div className="mx-auto max-w-7xl overflow-hidden">
            <h2 className=" my-5 mx-auto max-w-max rounded-full bg-slate-100 px-5 py-1 text-center text-2xl font-extrabold  text-purple-500">
              Our Team
            </h2>
            <p className=" stroke mx-auto max-w-6xl  text-center text-6xl font-extrabold leading-tight tracking-tight text-gray-800 sm:text-7xl 2xl:text-9xl">
              <span className="text-purple-500">ทีมงาน</span>ของ
              <br />
              กาลิเลโอ ติวเตอร์
            </p>
          </div>
        </div>
        <div className="rounded-3xl lg:mt-20  lg:bg-white lg:py-10 xl:mx-7">
          <div className="mx-5 grid gap-5 sm:mx-5 sm:mt-20 md:mx-5 md:grid-cols-2 lg:mx-7 lg:gap-10 xl:mx-auto xl:max-w-6xl 2xl:max-w-screen-2xl ">
            {ceo.map((person) => (
              <div className="relative my-5 rounded-3xl   bg-white sm:my-0 lg:bg-slate-200">
                <img src={person.imageUrl} className="mx-auto" alt="" />
                <div className="bottom-0 mx-auto max-w-xs rounded-3xl bg-white  p-5 lg:shadow-md  sm:absolute sm:bottom-5 sm:left-5 md:static md:left-0 md:mt-5 md:max-w-none  lg:relative  lg:max-w-sm xl:absolute xl:left-5 xl:max-w-xs ">
                  <p className="max-w-max rounded-full bg-purple-500 px-2 text-lg text-white">
                    {person.subject}
                  </p>

                  <h1 className="mt-3 text-3xl font-extrabold text-gray-800">
                    {person.nickname}
                  </h1>
                  <p className="mb-3 text-xl text-gray-500">{person.name}</p>
                  {person.modalImg ? (
                    <div className="moreButton">
                      <button
                        className="mt-2 border border-black px-4 py-1 text-black duration-150 ease-in-out hover:bg-black hover:text-white"
                        onClick={() => {
                          setSelectedItem(person);
                          setType("tutor");
                          setOpenDialog(true);
                        }}
                      >
                        รู้จักกับคุณครู <HiArrowUpRight className="inline" />
                      </button>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            ))}
          </div>
          <div className="mx-5 mb-20 grid gap-5 sm:mx-5 sm:mt-10 md:mx-5 md:grid-cols-2 lg:mx-7 lg:grid-cols-3 lg:gap-10 xl:mx-auto xl:max-w-6xl 2xl:max-w-screen-2xl">
            {tutor.map((person) => (
              <div className="relative my-5 rounded-3xl bg-white sm:my-0 lg:bg-slate-200">
                <img src={person.imageUrl} className="mx-auto" alt="" />
                <div className="bottom-0 mx-auto max-w-xs rounded-3xl bg-white p-5 lg:shadow-md sm:absolute sm:bottom-5 sm:left-5 md:relative md:left-0   md:mt-5 lg:max-w-[280px] xl:max-w-xs 2xl:absolute 2xl:left-5">
                  <p className="max-w-max rounded-full bg-purple-500 px-2 text-lg text-white">
                    {person.subject}
                  </p>

                  <h1 className="mt-3 text-3xl font-extrabold text-gray-800">
                    {person.nickname}
                  </h1>
                  <p className="mb-3 text-xl text-gray-500">{person.name}</p>
                  {person.modalImg ? (
                    <div className="moreButton">
                      <button
                        className="mt-2 border border-black px-4 py-1 text-black duration-150 ease-in-out hover:bg-black hover:text-white"
                        onClick={() => {
                          setSelectedItem(person);
                          setType("tutor");
                          setOpenDialog(true);
                        }}
                      >
                        รู้จักกับคุณครู <HiArrowUpRight className="inline" />
                      </button>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Modal
        isOpen={openDialog}
        selectedItem={selectedItem}
        type={type}
        handleClose={() => {
          setOpenDialog(false);
          setSelectedItem({});
        }}
      />

      <Footer />
    </div>
  );
}
